import { Provider } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
  EnvironmentConfig,
  ENVIRONMENT_CONFIG,
} from "../models/environment.model";

/**
 * Provider for chat environment configuration
 * This maps the environment.chat object to the EnvironmentConfig interface
 */
export function createEnvironmentConfigProvider(): Provider {
  return {
    provide: ENVIRONMENT_CONFIG,
    useValue: environment as EnvironmentConfig,
  };
}

/**
 * Alternative factory provider if you need more complex logic
 */
export function createEnvironmentConfigFactory(): EnvironmentConfig {
  return environment as EnvironmentConfig;
}

export const ENVIRONMENT_CONFIG_FACTORY_PROVIDER: Provider = {
  provide: ENVIRONMENT_CONFIG,
  useFactory: createEnvironmentConfigFactory,
};
